module.exports = __webpack_public_path__ + "img/119ne.36dc048c.svg";